import AccessGroupUserRemoveModal from './AccessGroupUserRemoveModal';

export default AccessGroupUserRemoveModal;
